// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_71e7feac","isFixed":"_4bafe4b3","image":"_bc8aec58","title":"_abe4b15f","icon":"_b01c1234","copy":"_28bb5da","message":"_cdf517f4","messageBold":"_42e59ab1"};